export default "__VITE_ASSET__CUwrxuOk__"